
<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
  </button>
</div>
<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../registroprofesores">Registro Profesores</a>
  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../crud-usuario"> Usuario</a>
  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../crear-encuesta">Crear Encuestas</a>
  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../menuReporte">Reportería</a>
  </li>

</ul>



  <div class="col-md-4"  style="margin-top: 5%; margin-left: 30%; margin-right: 200%">
    <div ></div>
    <form class="formulario-login">
      <h5 class="card-header">Registro Docentes</h5>

      <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-user"></i></span>
          </div>

          <input
            [class.is-invalid]="
              myForm.get('carnet').touched && myForm.get('carnet').invalid
            "
            type="text"
            class="form-control"
            placeholder="registro"
            formControlName="carnet"
            autofocus
          />
        </div>
        <div class="alert-danger" *ngIf=" myForm.get('carnet').invalid && (myForm.get('carnet').dirty || myForm.get('carnet').touched ) ">
          <div class="container-error-message" *ngIf="carnet.errors.required"  >
            El carnet es requerido
           </div>

        </div>

        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"
              ><i class="fas fa-user"></i
            ></span>
          </div>
          <input
            [class.is-invalid]="
              myForm.get('userName').touched &&
              myForm.get('userName').invalid
            "
            type="text"
            class="form-control"
            placeholder="nombre"
            formControlName="userName"
            autofocus
          />
        </div>
        <div class="alert-danger" *ngIf=" userName.invalid && (userName.dirty || userName.touched ) ">
          <div class="container-error-message" *ngIf="userName.errors.required"  >
            El nombre es requerido
           </div>
           <div class="container-error-message"  *ngIf="userName.errors.minlength" >
            Deben tener  min 4 letras
           </div>
        </div>
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"
              ><i class="fas fa-user-plus"></i
            ></span>
          </div>
          <input
            [class.is-invalid]="
              myForm.get('userLastName').touched &&
              myForm.get('userLastName').invalid
            "
            type="text"
            class="form-control"
            placeholder="apellido"
            formControlName="userLastName"
            autofocus
          />
        </div>
        <div class="alert-danger" *ngIf=" userLastName.invalid && (userLastName.dirty || userLastName.touched ) ">
          <div class="container-error-message" *ngIf="userLastName.errors.required"  >
            El apellido es requerido
           </div>
           <div class="container-error-message"  *ngIf="userLastName.errors.minlength" >
            Deben tener 4 letras min
           </div>

        </div>
        <div class="input-group form-group">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-key"></i></span>
          </div>
          <input
            [class.is-invalid]="
              myForm.get('userPass').touched && myForm.get('userPass').invalid
            "
            type="password"
            class="form-control"
            placeholder="contraseña"
            formControlName="userPass"
          />
        </div>
        <div class="alert-danger" *ngIf=" userPass.invalid && (userPass.dirty || userPass.touched ) ">
          <div class="container-error-message" *ngIf="userPass.errors.required"  >
            El contraseña es requerida
           </div>

           <div class="container-error-message"  *ngIf="userPass.errors.pattern" >
            Deben tener una mayúscula y un caracter
           </div>
        </div>
        <div class="form-group">
          <input
            type="submit"
            value="Enviar"
            class="btn float-right login_btn"

          />
        </div>

      </form>

      <div
        *ngIf="credentialsInvalid"
        class="alert alert-danger"
        role="alert"
        id="alertaLogin"
      >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
          <span aria-hidden="true">&times;</span>
        </button>
        <strong>Error</strong> {{ this.messageError }}


      </div>

    </form>
  </div>





